import { ApiService } from './ApiService';
const service = {};

service.getShapeAll = async () => {
    const res = await ApiService.get("/shape");
    return res.data;
}
  
export default service;